let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("76n7a"), load("l253H"), load("uP0oQ")]).then(() => parcelRequire('2XE2f'));